module.exports = __webpack_public_path__ + "static/media/check-primary.3a766cfc.svg";